import { DefaultTheme, css } from 'styled-components';

import { ColorName } from 'types';

const pickColor = (color: ColorName) => css`
  ${({ theme }: { theme: DefaultTheme }) => theme.colors[color]}
`;

const getHoverColor = (color: ColorName) => {
  switch (color) {
    case 'black':
      return 'grayDark';
    case 'darkRed':
      return 'colmarRed';
    case 'colmarBlue':
      return 'blue';
    default:
      return 'grayDark';
  }
};

export { pickColor, getHoverColor };
